var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIconOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1495_13668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4615 5.07692H5.07692C4.26087 5.07692 3.47824 5.4011 2.90121 5.97813C2.32417 6.55517 2 7.3378 2 8.15385V18.9231C2 19.7391 2.32417 20.5218 2.90121 21.0988C3.47824 21.6758 4.26087 22 5.07692 22H15.8462C16.6622 22 17.4448 21.6758 18.0219 21.0988C18.5989 20.5218 18.9231 19.7391 18.9231 18.9231V13.5385M18.1538 9.69231C19.1739 9.69231 20.1522 9.28709 20.8735 8.5658C21.5948 7.8445 22 6.86622 22 5.84615C22 4.82609 21.5948 3.84781 20.8735 3.12651C20.1522 2.40522 19.1739 2 18.1538 2C17.1338 2 16.1555 2.40522 15.4342 3.12651C14.7129 3.84781 14.3077 4.82609 14.3077 5.84615C14.3077 6.86622 14.7129 7.8445 15.4342 8.5658C16.1555 9.28709 17.1338 9.69231 18.1538 9.69231Z",
    stroke: "#5C6B3C",
    strokeWidth: 2.01681,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1495_13668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconOff);
export default __webpack_public_path__ + "static/media/Notification Icon Off.7f4f4d739469552f651775ecd61acd66.svg";
export { ForwardRef as ReactComponent };